var _path, _path2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricetagUncheckedOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9024 2.25H15.1415C14.9624 2.24987 14.7905 2.32065 14.6634 2.44688L3.14619 13.9641C2.89401 14.2175 2.75244 14.5605 2.75244 14.918C2.75244 15.2755 2.89401 15.6185 3.14619 15.8719L8.63057 21.3563C8.88399 21.6084 9.22696 21.75 9.58448 21.75C9.94199 21.75 10.285 21.6084 10.5384 21.3563L22.0509 9.84375C22.1771 9.71665 22.2479 9.54475 22.2478 9.36563V3.6C22.2486 3.42287 22.2144 3.24731 22.1472 3.08344C22.08 2.91957 21.981 2.77061 21.8559 2.64514C21.7309 2.51967 21.5823 2.42016 21.4187 2.35235C21.255 2.28453 21.0796 2.24975 20.9024 2.25Z",
    stroke: "currentColor",
    strokeWidth: 1.51667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7.4763C18.208 7.4763 17.9226 7.38972 17.6798 7.2275C17.437 7.06528 17.2478 6.83472 17.1361 6.56496C17.0243 6.2952 16.9951 5.99836 17.0521 5.71199C17.109 5.42561 17.2496 5.16256 17.4561 4.9561C17.6626 4.74963 17.9256 4.60903 18.212 4.55207C18.4984 4.4951 18.7952 4.52434 19.065 4.63608C19.3347 4.74781 19.5653 4.93703 19.7275 5.17981C19.8897 5.42259 19.9763 5.70802 19.9763 6C19.9763 6.39154 19.8208 6.76704 19.5439 7.0439C19.267 7.32076 18.8915 7.4763 18.5 7.4763Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.0473958
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.20711,
    y1: 1.29289,
    x2: 23.2071,
    y2: 21.2929,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricetagUncheckedOutlineIcon);
export default __webpack_public_path__ + "static/media/Pricetag_Unchecked_Outline_Icon.f388c026c5f92aa7c69ad1c9f832d153.svg";
export { ForwardRef as ReactComponent };